// Libs
import React from 'react';
import classNames from 'classnames';

/* h1, h2, h3, h4, h5, h6, subtitle1, subtitle2, body1, body2 */
const Description = props => <p className={classNames(['description', props.className])}>{props.content}</p>;

export default Description;
